'use client'
import { Button } from '@/components/button'
import { Card, CardContent, CardFooter, CardHeader } from '@/components/card'
import { ScrollArea } from '@/components/scroll-area'
import { Text } from '@/components/text'
import logger from '@/lib/logger'
import type { ErrorPageProps } from '@/types/next'
import { ChevronLeftIcon, RotateCcwIcon } from 'lucide-react'
import { useRouter } from 'next/navigation'
import type { JSX } from 'react'

export default function DefaultErrorPage(props: ErrorPageProps): JSX.Element {
    const { error, reset } = props
    const router = useRouter()

    logger.serverError(error)

    return (
        <ScrollArea className="flex h-full w-full flex-col items-center justify-center p-16">
            <Card>
                <CardHeader>
                    <Text type="title1">Errore</Text>
                </CardHeader>
                <CardContent align="center" className="min-h-32 flex-col items-center gap-4">
                    <Text type="small">Si è verificato una errore inaspettato!</Text>
                    <Text type="subtitle2">{error.message}</Text>
                </CardContent>
                <CardFooter align="right">
                    <Button
                        variant="white"
                        onClick={() => {
                            router.back()
                        }}
                    >
                        <ChevronLeftIcon className="size-4" />
                        Indietro
                    </Button>
                    <Button variant="soft" onClick={reset}>
                        <RotateCcwIcon className="size-4" />
                        Riprova
                    </Button>
                </CardFooter>
            </Card>
        </ScrollArea>
    )
}
